import React, { useCallback, useRef } from "react";

import MessageModal from "../../../components/HexModal/MessageModal";
import { emptyStateCopy } from "../filterSummary";

const SETTLE_MS = 260;

const AvailabilityDialog = ({
  cause,
  filters,
  summary,
  nearestKm,
  onDismiss,
  onWiden,
  onClearFilters,
}) => {
  const timerRef = useRef(0);

  const runAfterHide = useCallback(
    (action) => {
      onDismiss();

      window.clearTimeout(timerRef.current);
      timerRef.current = window.setTimeout(action, SETTLE_MS);
    },
    [onDismiss]
  );

  if (!cause || cause === "checking") return null;

  const copy = emptyStateCopy({ cause, filters, summary, nearestKm });

  const onOkay = () => {
    if (cause === "radius") runAfterHide(onWiden);
    else if (cause === "filters") runAfterHide(onClearFilters);
    else onDismiss();
  };

  return (
    <MessageModal
      open
      modalClass="home-dialog"
      title={copy.title}
      text={copy.body}
      buttonLabel={copy.confirmLabel}
      cancelText={copy.cancelLabel}
      onOkay={onOkay}
      onCancel={onDismiss}
      imageSrc={cause === "filters" ? "/assets/icons/no-search-result.png" : undefined}
    />
  );
};

export default React.memo(AvailabilityDialog);
